import { MailIcon } from '@src/components/atoms/icons/mail';
import { Spinner } from '@src/components/atoms/spinner';
import { ContentWithLink } from '@src/components/common/formatting/content-with-link';
import Seo from '@src/components/common/seo/seo';
import { SpotIllustration } from '@src/components/molecules/spot-illustration';
import { useCmsContent } from '@src/contexts/cms-content-context';
import { AuthLayout } from '@src/features/auth/components/auth-layout';

import { ResendEmailWrapper, VerifyResetPasswordWrapper } from './styles';
import { VerifyResetPasswordProps } from './types';

const VerifyResetPassword = ({ isLoading, onResendEmail }: VerifyResetPasswordProps) => {
  const content = useCmsContent();

  return (
    <VerifyResetPasswordWrapper>
      <Seo title={content.passwordResetEmailSent} />

      <AuthLayout.Header size="small">{content.passwordResetEmailSent}</AuthLayout.Header>

      <SpotIllustration>
        <MailIcon />
      </SpotIllustration>

      <ResendEmailWrapper>
        {isLoading ? <Spinner /> : <ContentWithLink contentKey="resendConfirmation" onClick={onResendEmail} />}
      </ResendEmailWrapper>
    </VerifyResetPasswordWrapper>
  );
};
export default VerifyResetPassword;
